export default "__VITE_ASSET__CuQWRSUu__"